module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1062.4f530780.png";